<template>
    <div id="mainDashboard">
        <md-app :class="{'fullDrawer': menuVisible}">
            <!-- toolbar -->
            <md-app-toolbar class="md-primary"
                md-elevation="0"
                id="topBar">
                <md-button class="md-icon-button"
                    @click="toggleMenu">
                    <md-icon>menu</md-icon>
                </md-button>
                <span class="md-title">Barbosa Peixe</span>
                <div class="md-toolbar-section-end">
                    <md-badge v-if="nrItemsInCart > 0"
                        class="md-primary"
                        :md-content="nrItemsInCart">
                        <md-button class="md-icon-button"
                            @click="toggleMiniCart">
                            <md-icon>shopping_cart</md-icon>
                        </md-button>
                    </md-badge>
                    <md-button v-else
                        class="md-icon-button"
                        @click="toggleMiniCart">
                        <md-icon>shopping_cart</md-icon>
                    </md-button>
                    <md-menu md-size="medium"
                        md-align-trigger
                        md-direction="bottom-end"
                        :md-offset-y="menuOffset">
                        <md-button class="md-icon-button"
                            md-menu-trigger>
                            <md-icon>account_box</md-icon>
                        </md-button>
                        <md-menu-content>
                            <md-menu-item class="userMenuItem"
                                v-if="isAdmin || isSuperUser"
                                @click="toRoute({path: '/organizations/'+$store.getters.user.organizationId+'/edit'})">
                                <md-icon>contacts</md-icon>
                                <span>{{ $tc('organizations.organization',1) }}</span>
                            </md-menu-item>
                            <md-menu-item class="userMenuItem"
                                @click="toRoute({path: '/organizations/'+$store.getters.user.organizationId+'/edit-user/'+$store.getters.user.userId})">
                                <md-icon>contacts</md-icon>
                                <span>{{ $tc('users.user',1) }}</span>
                            </md-menu-item>
                            <md-menu-item class="userMenuItem"
                                @click="logout">
                                <md-icon>logout</md-icon>
                                <span>{{ $t('actions.logout') }}</span>
                            </md-menu-item>
                        </md-menu-content>
                    </md-menu>
                </div>
            </md-app-toolbar>

            <!-- left drawer -->
            <md-app-drawer md-persistent="full"
                id="leftDrawer">
                <!-- drawer menu list -->
                <md-list>
                    <template v-if="isAdmin">
                        <md-list-item @click="toRoute('/dashboard')"
                            :class="{ 'active': $route.name === 'dashboard' }">
                            <md-icon>home</md-icon>
                            <span class="md-list-item-text">{{ $tc('general.home', 2) }}</span>
                            <md-tooltip v-if="!menuVisible"
                                md-direction="right"
                                md-delay="600">
                                {{ $tc('general.home', 2) }}
                            </md-tooltip>
                        </md-list-item>

                        <md-list-item @click="toRoute('/orders/new')"
                            :class="{ 'active': $route.name === 'add-order' || $route.name === 'checkout'}">
                            <md-icon>shopping_cart</md-icon>
                            <span class="md-list-item-text">{{ $tc('orders.catalog') }}</span>
                            <md-tooltip v-if="!menuVisible"
                                md-direction="right"
                                md-delay="600">
                                {{ $tc('orders.catalog') }}
                            </md-tooltip>
                        </md-list-item>

                        <md-list-item @click="toRoute('/orders')"
                            :class="{ 'active': $route.name === 'orders' || $route.name === 'edit-order' || $route.name === 'preview' }">
                            <md-icon>view_list</md-icon>
                            <span class="md-list-item-text">{{ $tc('orders.order', 2) }}</span>
                            <md-tooltip v-if="!menuVisible"
                                md-direction="right"
                                md-delay="600">
                                {{ $tc('orders.order', 2) }}
                            </md-tooltip>
                        </md-list-item>

                        <md-list-item @click="toRoute('/reports')"
                            :class="{ 'active': $route.name === 'reports' || $route.name === 'report-preview'}">
                            <md-icon>assessment</md-icon>
                            <span class="md-list-item-text">{{ $tc('reports.report', 2) }}</span>
                            <md-tooltip v-if="!menuVisible"
                                md-direction="right"
                                md-delay="600">
                                {{ $tc('reports.report', 2) }}
                            </md-tooltip>
                        </md-list-item>

                        <md-list-item @click="toRoute('/organizations')"
                            :class="{ 'active': $route.name === 'organizations' || $route.name === 'add-organization' || $route.name === 'edit-organization' || $route.name === 'add-user' || $route.name === 'edit-user' || $route.name === 'view-user' }">
                            <md-icon>people</md-icon>
                            <span class="md-list-item-text">{{ $tc('organizations.organization', 2) }}</span>
                            <md-tooltip v-if="!menuVisible"
                                md-direction="right"
                                md-delay="900">
                                {{ $tc('organizations.organization', 2) }}
                            </md-tooltip>
                        </md-list-item>

                        <md-list-item @click="toRoute('/products')"
                            :class="{ 'active': $route.name === 'products' || $route.name === 'add-product' || $route.name === 'edit-product' }">
                            <md-icon>fastfood</md-icon>
                            <span class="md-list-item-text">{{ $tc('products.product', 2) }}</span>
                            <md-tooltip v-if="!menuVisible"
                                md-direction="right"
                                md-delay="600">
                                {{ $tc('products.product', 2) }}
                            </md-tooltip>
                        </md-list-item>

                        <md-list-item @click="toRoute('/calibers')"
                            :class="{ 'active': $route.name === 'calibers' || $route.name === 'add-caliber' || $route.name === 'edit-caliber' }">
                            <md-icon>local_offer</md-icon>
                            <span class="md-list-item-text">{{ $tc('calibers.caliber', 2) }}</span>
                            <md-tooltip v-if="!menuVisible"
                                md-direction="right"
                                md-delay="600">
                                {{ $tc('calibers.caliber', 2) }}
                            </md-tooltip>
                        </md-list-item>

                        <md-list-item @click="toRoute('/units')"
                            :class="{ 'active': $route.name === 'units' || $route.name === 'add-unit' || $route.name === 'edit-unit' }">
                            <md-icon>category</md-icon>
                            <span class="md-list-item-text">{{ $tc('units.unit', 2) }}</span>
                            <md-tooltip v-if="!menuVisible"
                                md-direction="right"
                                md-delay="600">
                                {{ $tc('units.unit', 2) }}
                            </md-tooltip>
                        </md-list-item>

                        <md-list-item @click="toRoute('/posts')"
                            :class="{ 'active': $route.name === 'posts' || $route.name === 'add-post' || $route.name === 'edit-post' }">
                            <md-icon>art_track</md-icon>
                            <span class="md-list-item-text">{{ $tc('posts.post', 2) }}</span>
                            <md-tooltip v-if="!menuVisible"
                                md-direction="right"
                                md-delay="600">
                                {{ $tc('posts.post', 2) }}
                            </md-tooltip>
                        </md-list-item>
                    </template>
                    <template v-else-if="isSuperUser">
                        <md-list-item @click="toRoute('/dashboard')"
                            :class="{ 'active': $route.name === 'dashboard' }">
                            <md-icon>home</md-icon>
                            <span class="md-list-item-text">{{ $tc('general.home', 2) }}</span>
                            <md-tooltip v-if="!menuVisible"
                                md-direction="right"
                                md-delay="600">
                                {{ $tc('general.home', 2) }}
                            </md-tooltip>
                        </md-list-item>
                        <md-list-item @click="toRoute('/orders/new')"
                            :class="{ 'active': $route.name === 'add-order' || $route.name === 'checkout'}">
                            <md-icon>shopping_cart</md-icon>
                            <span class="md-list-item-text">{{ $tc('orders.catalog') }}</span>
                            <md-tooltip v-if="!menuVisible"
                                md-direction="right"
                                md-delay="600">
                                {{ $tc('orders.catalog') }}
                            </md-tooltip>
                        </md-list-item>
                        <md-list-item @click="toRoute('/orders')"
                            :class="{ 'active': $route.name === 'orders' || $route.name === 'edit-order' || $route.name === 'preview' }">
                            <md-icon>view_list</md-icon>
                            <span class="md-list-item-text">{{ $tc('orders.order', 2) }}</span>
                            <md-tooltip v-if="!menuVisible"
                                md-direction="right"
                                md-delay="600">
                                {{ $tc('orders.order', 2) }}
                            </md-tooltip>
                        </md-list-item>
                        <md-list-item @click="toRoute({path: '/organizations/' + $store.getters.user.organizationId + '/users'})"
                            :class="{ 'active': $route.name === 'organizations' || $route.name === 'add-organization' || $route.name === 'edit-organization' || $route.name === 'add-user' || $route.name === 'edit-user' || $route.name === 'view-user' }">
                            <md-icon>people</md-icon>
                            <span class="md-list-item-text">{{ $tc('users.user', 2) }}</span>
                            <md-tooltip v-if="!menuVisible"
                                md-direction="right"
                                md-delay="600">
                                {{ $tc('users.user', 2) }}
                            </md-tooltip>
                        </md-list-item>
                    </template>
                    <template v-else-if="isUser">
                        <md-list-item @click="toRoute('/dashboard')">
                            <md-icon>home</md-icon>
                            <span class="md-list-item-text">{{ $tc('general.home', 2) }}</span>
                            <md-tooltip v-if="!menuVisible"
                                md-direction="right"
                                md-delay="600">
                                {{ $tc('general.home', 2) }}
                            </md-tooltip>
                        </md-list-item>
                        <md-list-item @click="toRoute('/orders/new')"
                            :class="{ 'active': $route.name === 'add-order' || $route.name === 'checkout'}">
                            <md-icon>shopping_cart</md-icon>
                            <span class="md-list-item-text">{{ $tc('orders.catalog') }}</span>
                            <md-tooltip v-if="!menuVisible"
                                md-direction="right"
                                md-delay="600">
                                {{ $tc('orders.catalog') }}
                            </md-tooltip>
                        </md-list-item>
                        <md-list-item @click="toRoute('/orders')"
                            :class="{ 'active': $route.name === 'orders' || $route.name === 'edit-order' || $route.name === 'preview' }">
                            <md-icon>view_list</md-icon>
                            <span class="md-list-item-text">{{ $tc('orders.order', 2) }}</span>
                            <md-tooltip v-if="!menuVisible"
                                md-direction="right"
                                md-delay="600">
                                {{ $tc('orders.order', 2) }}
                            </md-tooltip>
                        </md-list-item>
                    </template>
                    <template v-else>
                        <md-list-item @click="toRoute('/dashboard')"
                            :class="{ 'active': $route.name === 'dashboard' }">
                            <md-icon>home</md-icon>
                            <span class="md-list-item-text">{{ $tc('general.home', 2) }}</span>
                            <md-tooltip v-if="!menuVisible"
                                md-direction="right"
                                md-delay="600">
                                {{ $tc('general.home', 2) }}
                            </md-tooltip>
                        </md-list-item>
                    </template>
                </md-list>
            </md-app-drawer>

            <!-- content -->
            <md-app-content>
                <h1 v-if="!['dashboard'].includes($route.name)">
                    {{ $route.meta.title }}
                </h1>
                <dashboard-content v-if="['dashboard'].includes($route.name)"></dashboard-content>
                <router-view>
                </router-view>
            </md-app-content>
        </md-app>
        <!-- right drawer -->
        <md-drawer class="md-right mini-cart"
            :md-active.sync="miniCartVisible"
            md-persistent="full"
            id="rightDrawer">
            <md-toolbar class="md-transparent"
                md-elevation="1">
                <span class="md-title">
                    {{ $t('general.shopping-cart') }}
                </span>
                <div class="md-toolbar-section-end">
                    <md-button class="md-icon-button md-dense"
                        @click="toggleMiniCart">
                        <md-icon>keyboard_arrow_right</md-icon>
                    </md-button>
                </div>
            </md-toolbar>
            <div class="mini-cart-list">
                <md-list class="md-third-line"
                    v-if="inCart.length > 0">
                    <div v-for="(item, index) in inCart[0].products"
                        :key="item.uuid"
                        no-action>
                        <mini-cart-item :item="item"
                            :index="index"
                            :in-checkout="inCheckout">
                        </mini-cart-item>
                        <md-divider v-if="(index < inCart[0].products.length-1)"
                            class="md-inset">
                        </md-divider>
                    </div>
                </md-list>
                <div v-if="nrItemsInCart === 0"
                    id="emptyCartNotification">
                    <p>{{ $t('validations.empty-cart') }}</p>
                    <md-button class="md-raised md-primary button-checkout"
                        @click="toCatalog()">
                        {{ $t('orders.new-order') }}
                    </md-button>
                </div>
            </div>
            <div v-if="nrItemsInCart > 0"
                id="checkoutButtonContainer">
                <md-divider></md-divider>
                <md-button class="md-raised md-primary button-checkout"
                    @click="checkout()">
                    {{ $t('actions.checkout') }}
                </md-button>
                <md-button class="button-continue-shopping"
                    @click="toCatalog()">
                    {{ $t('general.continue-shopping') }}
                </md-button>
            </div>
        </md-drawer>
        <div v-if="miniCartVisible"
            class="custom-md-overlay"
            @click="toggleMiniCart"></div>
        <transition name="fade">
            <v-btn color="primary"
                v-scroll="onScroll"
                v-show="showToTop"
                fab
                fixed
                bottom
                right
                small
                @click="toTop">
                <md-icon class="goto-top">
                    keyboard_arrow_up
                </md-icon>
            </v-btn>
        </transition>
    </div>
</template>

<script>
import _ from 'lodash'
import DashboardContent from '@/components/dashboard/Index'
import MiniCartItem from '@/components/orders/mini-cart/Item'
import organizationsService from '@/components/organizations/services/organizations'
import Swal from 'sweetalert2'
import luxon from '@/mixins/luxon'

export default {
    name: 'Dashboard',

    mixins: [luxon],

    components: {
        DashboardContent,
        MiniCartItem
    },

    data () {
        return {
            componentKey: 0,

            showToTop: false,

            menuVisible: false,

            miniCartVisible: false,

            menuOffset: 11,

            order: {
                order_id: null,
                organization_id: this.$store.getters.user.organizationId,
                user_id: this.$store.getters.user.userId,
                delivery_date: null,
                shipped_date: null,
                description: '',
                orderstatus_id: 1,
                active: 1,
                created_at: null,
                updated_at: null,
                organization_name: '',
                first_name: '',
                last_name: '',
                order_status: 'Pendente',
                preferred_delivery_hour: null,
                address: '',
                products: []
            },

            organization: {
                organization_name: '',
                nipc: '',
                phone: '',
                email: '',
                street: '',
                city: '',
                state: '',
                zip_code: '',
                preferred_delivery_hour: null,
                organization_picture_id: '',
                logo_picture_id: '',
                organization_picture_url: '',
                logo_picture_url: ''
            }
        }
    },

    computed: {
        isAdmin () {
            return this.$store.getters.user.role === 'ADMIN'
        },

        isSuperUser () {
            return this.$store.getters.user.role === 'SUPERUSER'
        },

        isUser () {
            return this.$store.getters.user.role === 'USER'
        },

        inCart () {
            return this.$store.getters.inCart || []
        },

        nrItemsInCart () {
            if (this.inCart.length > 0) {
                return this.inCart[0].products.length
            } else {
                return 0
            }
        },

        inCheckout () {
            return (this.$route.name === 'Checkout')
        }
    },

    methods: {
        toggleMenu () {
            this.menuVisible = !this.menuVisible
        },

        onScroll (e) {
            if (typeof window === 'undefined') return
            const top = window.pageYOffset || e.target.scrollTop || 0
            this.showToTop = top > 100
        },

        toTop () {
            this.$vuetify.goTo(0)
        },

        logout () {
            Swal.fire({
                title: this.$t('actions.logout'),
                text: this.$t('validations.question-item-confirm'),
                type: 'warning',
                showCloseButton: true,
                showCancelButton: true,
                cancelButtonText: this.$t('actions.cancel'),
                confirmButtonText: this.$t('actions.confirm'),
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    this.$store.dispatch('logout')
                        .then(() => { this.$router.push('/login') })
                        .catch(() => {
                            self.loginFailed()
                            self.errored = true
                        })
                }
            })
        },

        toggleMiniCart () {
            this.miniCartVisible = !this.miniCartVisible
            if (this.miniCartVisible) {
                document.documentElement.style.overflowY = 'hidden'
            } else {
                document.documentElement.style.overflowY = 'auto'
            }
        },

        checkout () {
            this.miniCartVisible = false
            document.documentElement.style.overflowY = 'auto'
            this.$router.push('/orders/checkout')
        },

        toCatalog () {
            this.toggleMiniCart()
            this.$router.push('/orders/new')
        },

        toRoute (destination) {
            this.$router.push(destination)
        },

        concatOrganizationAddress (organization) {
            return (
                (organization[0].street ? organization[0].street + '\n' : '') +
                (organization[0].zip_code ? organization[0].zip_code + '\n' : '') +
                (organization[0].city ? organization[0].city + '\n' : '')
            )
        },

        makeDeliveryDateTime (deliveryDate, deliveryTime) {
            let year = deliveryDate.getFullYear()

            let month = deliveryDate.getMonth() + 1
            if (month < 10) {
                month = '0' + month
            }

            let day = deliveryDate.getDate()
            if (day < 10) {
                day = '0' + day
            }

            let deliveryHours = deliveryTime.split(':')[0]
            if (deliveryHours.length < 2) {
                deliveryHours = '0' + deliveryHours
            }

            let deliveryMinutes = deliveryTime.split(':')[1]
            if (deliveryMinutes.length < 2) {
                deliveryMinutes = '0' + deliveryMinutes
            }

            let deliveryDateTimeString = year + '-' + month + '-' + day + ' ' + deliveryHours + ':' + deliveryMinutes

            return deliveryDateTimeString
        },

        async fetchOrganization () {
            let self = this

            let params = {
                filter: {
                    organization_id: this.$store.getters.user.organizationId
                }
            }

            let response = await organizationsService.retrieve(params)
            self.organization = _.cloneDeep(response.data.results)

            self.order.organization_name = (self.organization[0].organization_name ? self.organization[0].organization_name : '')
            self.order.preferred_delivery_hour = this.formatTimeSimple(self.organization[0].preferred_delivery_hour)
            self.order.address = self.concatOrganizationAddress(self.organization)
            self.order.delivery_date = this.makeDeliveryDateTime(new Date(), self.order.preferred_delivery_hour)
            self.order.first_name = this.$store.getters.user.firstName
            self.order.last_name = this.$store.getters.user.lastName
        }
    },

    created () {
        let metadatas = [
            this.fetchOrganization(),
            this.$store.dispatch('initCart', this.order)
        ]
        Promise.all(metadatas)
    }
}
</script>

<style scoped>
html,
body {
    overflow-x: hidden;
}
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
